var _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFile({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 21,
    viewBox: "0 0 16 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.4976 6.89607C15.4951 6.73346 15.4307 6.5801 15.3147 6.4631C9.22951 0.377894 9.6617 0.793332 9.54404 0.730614C9.34132 0.622322 9.87087 0.656844 1.85882 0.656844C1.11062 0.656844 0.501953 1.26555 0.501953 2.01372V19.2947C0.501953 20.0429 1.11062 20.6516 1.85882 20.6516H14.1412C14.8893 20.6516 15.498 20.0429 15.498 19.2947C15.498 19.1247 15.4983 6.94715 15.4976 6.89607ZM9.87446 2.79015L13.3647 6.28037H9.98166C9.92253 6.28037 9.87446 6.2323 9.87446 6.17317V2.79015ZM14.1411 19.4019H1.85882C1.7997 19.4019 1.75163 19.3539 1.75163 19.2947V2.01372C1.75163 1.95459 1.7997 1.90652 1.85882 1.90652H8.62483V6.17317C8.62483 6.92134 9.23353 7.53005 9.9817 7.53005H14.2484V19.2947C14.2483 19.3539 14.2002 19.4019 14.1411 19.4019Z",
    fill: "#F0F0F0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1242 17.8398H4.87581C4.53075 17.8398 4.25098 17.56 4.25098 17.2149C4.25098 16.8698 4.53075 16.5901 4.87581 16.5901H11.1242C11.4693 16.5901 11.749 16.8698 11.749 17.2149C11.749 17.56 11.4693 17.8398 11.1242 17.8398Z",
    fill: "#F0F0F0"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1242 15.3405H4.87581C4.53075 15.3405 4.25098 15.0608 4.25098 14.7157C4.25098 14.3706 4.53075 14.0908 4.87581 14.0908H11.1242C11.4693 14.0908 11.749 14.3706 11.749 14.7157C11.749 15.0608 11.4693 15.3405 11.1242 15.3405Z",
    fill: "#F0F0F0"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1242 12.8412H4.87581C4.53075 12.8412 4.25098 12.5615 4.25098 12.2164C4.25098 11.8713 4.53075 11.5916 4.87581 11.5916H11.1242C11.4693 11.5916 11.749 11.8713 11.749 12.2164C11.749 12.5615 11.4693 12.8412 11.1242 12.8412Z",
    fill: "#F0F0F0"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M11.1242 10.3417H4.87581C4.53075 10.3417 4.25098 10.062 4.25098 9.71688C4.25098 9.37177 4.53075 9.09204 4.87581 9.09204H11.1242C11.4693 9.09204 11.749 9.37177 11.749 9.71688C11.749 10.062 11.4693 10.3417 11.1242 10.3417Z",
    fill: "#F0F0F0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFile);
export default __webpack_public_path__ + "static/media/file.5ec15922dc67e202c01e8373e66ff1ab.svg";
export { ForwardRef as ReactComponent };